/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SplitOrderReqSplitGoodsVo
 */
export interface SplitOrderReqSplitGoodsVo {
    /**
     * 商品id
     * @type {number}
     * @memberof SplitOrderReqSplitGoodsVo
     */
    goodsId?: number;
    /**
     * 分单商品数量 如果想把商品整个分出去，就不传这个值
     * @type {number}
     * @memberof SplitOrderReqSplitGoodsVo
     */
    splitGoodsNum?: number;
}

/**
 * Check if a given object implements the SplitOrderReqSplitGoodsVo interface.
 */
export function instanceOfSplitOrderReqSplitGoodsVo(value: object): value is SplitOrderReqSplitGoodsVo {
    return true;
}

export function SplitOrderReqSplitGoodsVoFromJSON(json: any): SplitOrderReqSplitGoodsVo {
    return SplitOrderReqSplitGoodsVoFromJSONTyped(json, false);
}

export function SplitOrderReqSplitGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitOrderReqSplitGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'splitGoodsNum': json['splitGoodsNum'] == null ? undefined : json['splitGoodsNum'],
    };
}

export function SplitOrderReqSplitGoodsVoToJSON(json: any): SplitOrderReqSplitGoodsVo {
    return SplitOrderReqSplitGoodsVoToJSONTyped(json, false);
}

export function SplitOrderReqSplitGoodsVoToJSONTyped(value?: SplitOrderReqSplitGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'splitGoodsNum': value['splitGoodsNum'],
    };
}

